export default {
  CLOSED: 'CLOSED',
  // An INTERRUPTED port call is missing events required to properly close a port call
  INTERRUPTED: 'INTERRUPTED',
  OPEN: 'OPEN',
}
